export const VALIDATORS = {
  "name": [
    {
      errorName: "required",
      errorDescription: "Bắt buộc nhập tên menu"
    },
  ],
  "menuCode": [
    {
      errorName: "required",
      errorDescription: "Bắt buộc nhập mã menu"
    },
  ],
}
